export var InstanceState;

(function (InstanceState) {
  InstanceState["Valid"] = "VALID";
})(InstanceState || (InstanceState = {}));

export var Name;

(function (Name) {
  Name["Coravin"] = "Coravin";
  Name["HalfBottles"] = "Half Bottles";
  Name["Splits"] = "Splits";
  Name["The15LiterMagnum"] = "1.5 Liter (Magnum)";
  Name["The3Liter"] = "3 Liter";
  Name["The90PtClub"] = "90 Pt. Club";
})(Name || (Name = {}));

export var CATEGORIES;

(function (CATEGORIES) {
  CATEGORIES["varietalName"] = "VARIETAL";
  CATEGORIES["flavorName"] = "FLAVOR";
  CATEGORIES["regionName"] = "REGION";
  CATEGORIES["NinetyPointClub"] = "90_POINT_CLUB";
  CATEGORIES["halfBottles"] = "HALF_BOTTLES";
  CATEGORIES["largeFormat"] = "LARGE_FORMAT";
  CATEGORIES["pairings"] = "FOOD_PAIRINGS";
})(CATEGORIES || (CATEGORIES = {}));

export var WineSize;

(function (WineSize) {
  WineSize["HALF_BOTTLE"] = "HALF_BOTTLE";
  WineSize["LARGE_FORMAT"] = "LARGE_FORMAT";
  WineSize["BOTTLE"] = "BOTTLE";
})(WineSize || (WineSize = {}));

export var FilterNames;

(function (FilterNames) {
  FilterNames["REGION"] = "REGION";
  FilterNames["FLAVOR"] = "FLAVOR";
  FilterNames["PRICE"] = "PRICE";
  FilterNames["VINTAGE"] = "VINTAGE";
  FilterNames["SIZE"] = "SIZE";
  FilterNames["VARIETAL"] = "VARIETAL";
  FilterNames["PAIRINGS"] = "PAIRINGS";
})(FilterNames || (FilterNames = {}));